/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Visibility_HiddenInputs */



/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Style_Guide_Manager_Visibility_HiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_visibility_hidden = /** @type {((inputs?: Style_Guide_Manager_Visibility_HiddenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Visibility_HiddenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masque")
	if (locale === "de") return /** @type {LocalizedString} */ ("Versteckt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nascosto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скрытый")
	if (locale === "es") return /** @type {LocalizedString} */ ("Oculto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("隠れた")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छिपा हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escondido")
	return /** @type {LocalizedString} */ ("Hidden")
});